import { render, staticRenderFns } from "./MoveInCustomerDetails.vue?vue&type=template&id=4155458a&scoped=true"
import script from "./MoveInCustomerDetails.vue?vue&type=script&lang=js"
export * from "./MoveInCustomerDetails.vue?vue&type=script&lang=js"
import style0 from "./MoveInCustomerDetails.vue?vue&type=style&index=0&id=4155458a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4155458a",
  null
  
)

export default component.exports